import React, { FC } from "react";
import { Box, IconButton, Modal } from "@mui/material";
import styles from "./MainModal.styled";
import IMainModalProps from "./types";
import CloseIcon from "@mui/icons-material/Close";

const MainModal: FC<IMainModalProps> = ({
  isOpen,
  handleClose,
  children,
  sxWrap,
  sx,
}) => {
  const modalWrapStyles = {
    ...styles.modalWrap,
    ...sxWrap,
  };

  const modalStyles = {
    ...styles.modalContainer,
    ...sx,
  };

  const handleCloseModal = (
    event: React.MouseEvent<HTMLElement>,
    reason: "backdropClick" | "escapeKeyDown",
  ) => {
    if (reason === "backdropClick") {
      return;
    }
    handleClose && handleClose();
  };

  return (
    <Modal open={isOpen} onClose={handleCloseModal} sx={modalWrapStyles}>
      <Box sx={modalStyles}>
        <IconButton
          aria-label="Close"
          onClick={handleClose}
          sx={styles.modalIconClose}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={styles.modalContent}>{children}</Box>
      </Box>
    </Modal>
  );
};

export default MainModal;
